import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import { DropdownItemContainer } from './NotificationStyles';

const NotificationItemComponent = ({ toggleNotificationModal, onMarkAsRead, onErrorMessageChange, notification, text, onDismiss, idx }) => {
  const onItemClick = notification => {
    if (notification.fromToast) {
      toggleNotificationModal();
      onErrorMessageChange(notification.notificationBody);
    }
    onMarkAsRead(notification)();
  };

  return (
    <DropdownItemContainer>
      <div onClick={() => onItemClick(notification)} style={{ display: 'inline-block' }}>
        <Typography>{notification.isRead ? text : <b>{text}</b>}</Typography>
      </div>
      <IconButton
        id={'offerHeader_notifications_' + idx}
        onClick={onDismiss(notification)}
        color='secondary'
        variant='text'
        size='tiny'
        type={'cancel'}
      />
    </DropdownItemContainer>
  );
};

NotificationItemComponent.propTypes = {
  notification: PropTypes.object.isRequired,
  toggleNotificationModal: PropTypes.func.isRequired,
  onErrorMessageChange: PropTypes.func.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  text: PropTypes.string,
  idx: PropTypes.number
};

export default React.memo(NotificationItemComponent);
